import Icon from "@mdi/react";
import { mdiWallet } from "@mdi/js";
import { mdiLoading } from "@mdi/js";
import Button from "components/Button";
import Modal from "components/Modal";
import { getWalletOnboardingUrlAPI } from "services/api/haulpay";
import { showErrorMessage } from "helpers/toastMessage";
import { useState } from "react";

type IProps = {
  isConfirmModalOpen: boolean;
  toggleConfirmModal: () => void;
};

export default function OnboardingModal({ isConfirmModalOpen, toggleConfirmModal }: IProps) {
  const [isFetching, setIsFetching] = useState(false);
  const getWalletOnboardingUrl = async () => {
    try {
      setIsFetching(true);
      const response = await getWalletOnboardingUrlAPI();
      if (response.data) {
        window.location.replace(response.data?.url);
      }
    } catch (error: any) {
      showErrorMessage(error.message);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <Modal
      isOpen={isConfirmModalOpen}
      closeModal={toggleConfirmModal}
      isDisableCloseModal
      wrapperClass="!my-auto desktop:!min-h-fit text-sm"
      dialogClass="!bg-foreground !p-6 desktop:!p-10 !border !border-card !overflow-y-auto gap-2.5 mx-auto"
      closeClass="!hidden">
      <Icon path={mdiWallet} className="mx-auto size-18 text-primary" />

      <span className="mt-4 mb-2 desktop:text-lg">
        Please first complete the onboarding process.
      </span>
      <Button type="button" onClick={getWalletOnboardingUrl}>
        Continue
        {isFetching && <Icon path={mdiLoading} size={1} spin={1} />}
      </Button>
    </Modal>
  );
}
